export const QUERY_KEY_HISTORY = 'History'
export const QUERY_KEY_HISTORY_BY_ID = 'HistoryById'
